export default "__VITE_ASSET__DrVCn1Ih__"